// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { GridOffset } from "@stanion/MobiusOverrides/GridContainer";
import { xScreen } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

actionStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            order: 1;
            margin-left: 5px;
        `,
    },
};

actionStyles.removeSelectedButton = {
    ...actionStyles.removeSelectedButton,
    variant: "secondary",
};

actionStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        column-gap: 15px;
    `,
};

actionStyles.printListModal = {
    container: {
        gap: 0,
        css: css`
            ${GridOffset} {
                gap: 10px;
            }
        `,
    },
    productPropertiesCheckboxGridContainer: {
        gap: 0,
        css: css`
            ${GridOffset} {
                gap: 10px;

                ${xScreen("lte", "sm")} {
                    gap: 0;
                }
            }
            ${GridItemStyle} {
                padding: 10px 0;
            }
        `,
    },
    barcodeTypeRadioGroup: {
        horizontal: true,
        css: css`
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                align-items: baseline;
                gap: 10px;
            }
        `,
    },
    productPropertiesCheckboxGridItem: {
        width: 12,
        css: css`
            gap: 15px;

            ${xScreen("lte", "sm")} {
                flex-direction: column;
                align-items: baseline;
            }
        `,
    },
    submitButton: {
        color: "primary",
        variant: "primary",
    },
};
